import { render, staticRenderFns } from "./footer-card2.vue?vue&type=template&id=c23a5aac&scoped=true&"
import script from "./footer-card2.vue?vue&type=script&lang=js&"
export * from "./footer-card2.vue?vue&type=script&lang=js&"
import style0 from "./footer-card2.vue?vue&type=style&index=0&id=c23a5aac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a5aac",
  null
  
)

export default component.exports